import { ForecastPeriod } from './types';

export const PAGE_SIZE = 10;
export const DEFAULT_PERIOD: ForecastPeriod = 'this_week';
